// Material Dashboard 2 PRO React base styles
import borders from "assets/theme-dark/base/borders";

const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.md,
    },
  },
};

export default popover;
